import {light} from './light'
import {dark} from './dark'
import { mode } from '../types'
import { Color } from '../types/color'

export const colors = (mode: mode = 'light'): Color => {
    if(mode === 'light') return light
    return dark
}
